export let findTimeDescription = "Y2OKA";
export let attachSignatureButtonDesc = "y9EoHd";
export let encryptDesc = "wWFu6";
export let sensitivityDesc = "If8oMe";
export let printDraftDesc = "zs1eVe";
export let saveDraftDesc = "$aEnH";
export let saveDraftAsDesc = "vRJ_n";
export let readReceiptDesc = "p2k$fc";
export let deliveryReceiptDesc = "JRkIMe";
export let attachFileDesc = "EEt6Rb";
export let getMessageExtensionsDesc = "oSB4Qb";
export let getAddinsDesc = "Ce0fVc";
export let pollsDesc = "ZlnK9d";
export let proofingOptionsDescription = "wjl7wd";
export let scheduleSendDesc = "mgptZ";
export let switchToPlainTextTooltip = "zJCQxe";
export let switchToHTMLTooltip = "hdFgJ";
export let showMoreOptionsDesc = "VvMfrd";
export let highImportanceDesc = "rHvGic";
export let lowImportanceDesc = "HeXWwd";
export let deviceNotCompliantForLoopsFluidHero = "S_DJJb";
export let loopMenuDescriptionTooltip = "q34RPc";
export let loopMenuTitleTooltip = "oq_rad";
export let recordVideoDesc = "jB$AE";
export let disallowReactionsDesc = "kbmmt";
export let draftWithCopilotDescriptionTooltip = "IF9Qtc";
export let coachWithCopilotDescriptionTooltip = "lC9eXc";
export let mailTemplateAsDesc = "Q$f2Hc";
export let showFieldsDesc = "dgKy3b";
export let trackingDesc = "m69Vhe";
export let quickPartsAsDesc = "cUnjl";
export let checkNameDesc = "obwzNb";
export default {findTimeDescription,attachSignatureButtonDesc,encryptDesc,sensitivityDesc,printDraftDesc,saveDraftDesc,saveDraftAsDesc,readReceiptDesc,deliveryReceiptDesc,attachFileDesc,getMessageExtensionsDesc,getAddinsDesc,pollsDesc,proofingOptionsDescription,scheduleSendDesc,switchToPlainTextTooltip,switchToHTMLTooltip,showMoreOptionsDesc,highImportanceDesc,lowImportanceDesc,deviceNotCompliantForLoopsFluidHero,loopMenuDescriptionTooltip,loopMenuTitleTooltip,recordVideoDesc,disallowReactionsDesc,draftWithCopilotDescriptionTooltip,coachWithCopilotDescriptionTooltip,mailTemplateAsDesc,showFieldsDesc,trackingDesc,quickPartsAsDesc,checkNameDesc};